import { render, staticRenderFns } from "./ProjectAnchorsCard.vue?vue&type=template&id=3e6fae15&scoped=true"
import script from "./ProjectAnchorsCard.vue?vue&type=script&lang=js"
export * from "./ProjectAnchorsCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectAnchorsCard.vue?vue&type=style&index=0&id=3e6fae15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6fae15",
  null
  
)

export default component.exports